/* eslint-disable camelcase */
const RUN_LABELS = {
  grouped_merge_request_update: "Existing grouped MR update",
  merge_request_update: "Existing MR update",
  security_update: "Security update",
  version_update: "Dependency update"
};

export function runLabel(name) {
  return RUN_LABELS[name] ?? "Update run";
}
